import { Component, OnInit, Input, Output, OnChanges, EventEmitter, ElementRef } from '@angular/core';

@Component({
  selector: 'lib-team-tool-tip',
  templateUrl: './team-tool-tip.component.html',
  styleUrls: ['./team-tool-tip.component.scss']
})
export class TeamToolTipComponent implements OnInit, OnChanges {

  @Input() teamDisplayText;
  @Input() teamPopUpPosition;
  @Input() teamPopUpDirection;
  @Output() TeamcloseEmitter = new EventEmitter();
  xPos = 100;
  yPos = 100;
  toolTipArrowPos:boolean

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges() {
    let xDir = this.teamPopUpDirection?12:-12;
    this.xPos = this.teamPopUpPosition.xPos + xDir;
    this.yPos = this.teamPopUpPosition.yPos;
  }

  close(event) {
    if (event)
      event.stopPropagation();
    this.TeamcloseEmitter.emit(event)
  }

}
